export default "__VITE_PUBLIC_ASSET__475d22d2__"